import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { PositiveIcon } from "../../../../common/icons";
import { injectIntl, defineMessages, FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import HUBContext from "../../../../services/HUBContext";
import { translations } from "./constants";
import { styles } from "./UploadFileConclusion.styles";

const messages = defineMessages(translations);

export class UploadFileConclusionBase extends React.Component {
  render() {
    const { classes, itemsChanged, hasSolutions, intl } = this.props;
    const { company } = this.context;

    return (
      <div className={classes.container}>
        <div className={classes.innerContainer}>
          <div className={classes.headerSection}>
            <div className={classes.iconWrapper}>
              <div className={classes.checkIcon}>
                <PositiveIcon />
              </div>
              <span className={classes.statusText}>
                {intl.formatMessage(messages.status)}
              </span>
            </div>

            <h1 className={classes.title}>
              {intl.formatMessage(messages.title)}
            </h1>
            <p className={classes.subtitle}>
              {intl.formatMessage(messages.subtitle)}
            </p>

            <div className={classes.badge}>
              <FormattedMessage
                {...messages.itemsChanged}
                values={{ items: itemsChanged }}
              />
            </div>
          </div>

          {hasSolutions && (
            <div className={classes.nextStepContainer}>
              <h3 className={classes.nextStepTitle}>
                {intl.formatMessage(messages.nextStepTitle)}
              </h3>
              <div className={classes.nextStepTextContainer}>
                <p className={classes.nextStepText}>
                  <FormattedMessage
                    {...messages.nextStepDescription}
                    values={{
                      link: (
                        <Link
                          to={`/app/${company?.companyID || 0}/vehicle/single-registry/sync-history`}
                          className={classes.link}
                        >
                          {intl.formatMessage(messages.nextStepLinkText)}
                        </Link>
                      ),
                    }}
                  />
                </p>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export class UploadFileConclusion extends UploadFileConclusionBase {}

UploadFileConclusion.contextType = HUBContext;
export default withStyles(styles)(injectIntl(UploadFileConclusion));
